import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../redux/store";
import {
  useAddProjetMutation,
  useDeleteProjetMutation,
} from "../../../../utils/api/launchCampagn/projet.api";
import { Projet } from "../../../../utils/api/launchCampagn/projet.type";
import { getRoutePath } from "../../../routes/routes";

const useOnDelete = (projet: Projet) => {
  const isAdmin = useAppSelector((s) => s.user.user?.user_type === "admin");
  const [
    deleteProject,
    { isLoading: loading1, isSuccess: sucess1, isError: error1 },
  ] = useDeleteProjetMutation();

  const [
    updateProjet,
    { isLoading: loading2, isSuccess: sucess2, isError: error2 },
  ] = useAddProjetMutation();

  return {
    deleteProject: () => {
      if (!isAdmin) {
        return updateProjet({ id: projet.id, data: { archiver: true } });
      }

      return deleteProject(projet.id);
    },
    isLoading: loading1 || loading2,
    isSuccess: sucess1 || sucess2,
    isError: error1 || error2,
  };
};

export function DeleteProjectModal({
  modalId,
  onHide,
  projet,
}: {
  modalId: string;
  onHide: () => any;
  projet: Projet;
}) {
  const navigate = useNavigate();
  const { deleteProject, isError, isLoading, isSuccess } = useOnDelete(projet);
  const isAdmin = useAppSelector((s) => s.user.user?.user_type === "admin");
  const onHide2 = () => {
    onHide();
    if (isSuccess) {
      navigate(getRoutePath(isAdmin ? "ListeDesProjetsAdmin" : "ListeProjets"));
    }
  };
  React.useEffect(() => {
    return () => onHide();
  }, []);
  return (
    <div
      className="modal fade"
      id={modalId}
      data-bs-backdrop="static"
      data-backdrop="false"
      data-bs-keyboard="false"
      aria-labelledby="staticBackdrop2Label"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content custom-modal-investissement">
          <div className="modal-header modal-header-investissement-confirm">
            <button
              type="button"
              className="btn-close"
              onClick={onHide2}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body modal-invessetissement-body">
            <div className="modal-investissement-description-content2">
              {isSuccess && (
                <>
                  <div className="modal-investissement-description-confirm">
                    succès
                  </div>
                  <div className="modal-investissement-confirm-para-container">
                    <div className="modal-investissement-confirm-para">
                      Projet supprimé avec succès
                    </div>
                  </div>
                </>
              )}
              {isError && (
                <>
                  <div className="modal-investissement-description-confirm">
                    Erreur
                  </div>
                  <div className="modal-investissement-confirm-para-container">
                    <div className="modal-investissement-confirm-para">
                      Projet non supprimé
                    </div>
                  </div>
                </>
              )}
              {!isSuccess && !isError && (
                <>
                  <div className="modal-investissement-description-confirm">
                    Confirmation de suppression
                  </div>
                  <div className="modal-investissement-confirm-para-container">
                    <div className="modal-investissement-confirm-para">
                      êtes-vous sûr de vouloir supprimer le projet {projet.name}
                    </div>
                  </div>
                  <div className="modal-investissement-montants-button-container">
                    <button
                      type="button"
                      disabled={isLoading}
                      className="btn modal-investissement-confirm-btn-annuler"
                      onClick={onHide2}
                    >
                      Annuler
                    </button>
                    {isLoading && (
                      <button
                        type="button"
                        className="btn modal-investissement-montants-btn-continuer"
                      >
                        Chargement...
                      </button>
                    )}
                    {!isLoading && (
                      <button
                        type="button"
                        onClick={() => deleteProject()}
                        className="btn modal-investissement-montants-btn-continuer"
                      >
                        Confirmer
                      </button>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
